export default "__VITE_ASSET__9cf78299__"